
import Industries from "../../components/layouts/Industries.vue";

import Hero from "../../components/industries/Hero.vue";
import IndustriesGrid from "../../components/industries/IndustriesGrid.vue";
import RowSection from "../../components/industries/RowSection.vue";
import ContactInfo from "../../components/industries/ContactInfo.vue";

export default {
  components: {
    Hero,
    Industries,
    IndustriesGrid,
    RowSection,
    ContactInfo,
  },
  data() {
    return {
      industriesGrid: [
        {
          title: "Commercial Trucking Loans",
          image: "industries/industries-commercial-trucking.jpg",
          routeName: "industries/commercial-truck-financing",
        },
        {
          title: "Business Loans for Contractors",
          image: "industries/industries-contractors.jpg",
          routeName: "industries/loans-for-contractors",
        },
        {
          title: "Construction Loans for Businesses",
          image: "industries/industries-construction.jpg",
          routeName: "industries/commercial-construction-loans",
        },
        {
          title: "Business Loans for Manufacturers",
          image: "industries/industries-manufacturing.jpg",
          routeName: "industries/manufacturing-financing",
        },
        {
          title: "Excavator Financing for Businesses",
          image: "industries/industries-excavation.jpg",
          routeName: "industries/excavator-financing",
        },
        {
          title: "Restaurant Business Loans",
          image: "industries/industries-restaurant.jpg",
          routeName: "industries/loans-for-restaurants",
        },
        {
          title: "Landscaping Business Loans",
          image: "industries/industries-landscaping.jpg",
          routeName: "industries/loans-for-landscapers",
        },
        {
          title: "Transportation Business Loans",
          image: "industries/industries-transportation.jpg",
          routeName: "industries/transportation-business-loans",
        },
        {
          title: "Commercial Auto Loans for Businesses",
          image: "industries/industries-commercial-auto.jpg",
          routeName: "industries/commercial-vehicle-loans",
        },
        {
          title: "Farming Business Loans",
          image: "industries/industries-farming.jpg",
          routeName: "industries/loans-for-farmers",
        },
        {
          title: "Working Capital Financing",
          image: "industries/working-capital-financing.jpg",
          routeName: "industries/working-capital-financing",
        },
        {
          title: "Commercial Real Estate Loans",
          image: "industries/commercial-real-estate-loans.jpg",
          routeName: "industries/commercial-real-estate-loans",
        },
      ],
    };
  },
  mounted() {
  },
  head() {
    return {
      title: 'Industries Served - Business Financing | American Credit',
      meta : [
        {
          hid: 'description',
          name: 'description',
          content: 'We offer business financing & equipment loans to many industries including construction, contracting, restaurants, trucking, landscaping & more! Apply today!'
        }
      ]
    }
  }
};
